import { SliderColorStyle } from "../../../types/Interface";

export function getSliderCoords(dim: { WIDTH: number, HEIGHT: number }, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL) {
  return dim.WIDTH > dim.HEIGHT ? SLIDERS_COORD : SLIDERS_COORD_OFFSET_VERTICAL.map(o => ({ x: dim.WIDTH / 2 + o.x, y: dim.HEIGHT / 2 + o.y }));
}

export function generateSliderProps(coord, head, colors: SliderColorStyle, subHead: string = "") {
  return {
    x: coord.x,
    y: coord.y,
    head,
    subHead,
    sliderStyle: colors
  }
}